"use client";

import { cn } from "@/lib/utils";
import { StockStatus } from "@/services/product/product.config";
import { Paragraph } from "@app/_components/ui/Paragraph";
import useTranslate from "@app/_hooks/useTranslate";
import type { CustomProduct } from "@apptus/esales-api";
import { useMarket } from "@features/market/useMarket";
import getProductStockStatus from "@features/product/utils/getProductStockStatus";

export default function ProductCardStockStatus({
  product,
  className,
  stockIcon = true,
}: {
  product: CustomProduct;
  className?: string;
  stockIcon?: boolean;
}) {
  const t = useTranslate();
  const market = useMarket();
  const stockStatus = getProductStockStatus(product, market);

  if (
    stockStatus.code === StockStatus.Incoming ||
    stockStatus.code === StockStatus.PendingSoldOut ||
    stockStatus.code === StockStatus.StockItem ||
    stockStatus.code === StockStatus.PendingOutOfStock
  ) {
    return (
      <div
        className={cn(
          "flex flex-row items-center justify-start gap-x-2 text-sm",
          className,
        )}
      >
        {stockIcon && (
          <output className="inline-flex size-2 shrink-0 rounded-full bg-green-500" />
        )}
        <Paragraph>
          {stockStatus.code === StockStatus.Incoming
            ? t("inStockSoon")
            : t("inStock")}
        </Paragraph>
      </div>
    );
  }
  if (
    stockStatus.code === StockStatus.OutOfStock ||
    stockStatus.code === StockStatus.SoldOut
  ) {
    return (
      <div
        className={cn(
          "flex flex-row items-center justify-start gap-x-2 text-sm",
          className,
        )}
      >
        {stockIcon && (
          <output className="inline-flex size-2 shrink-0 rounded-full bg-gray-500" />
        )}
        <Paragraph>
          {stockStatus.code === StockStatus.OutOfStock
            ? t("outOfStock")
            : t("soldOut")}
        </Paragraph>
      </div>
    );
  }
  return null;
}

ProductCardStockStatus.displayName = "ProductCardStockStatus";
